import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, BrowserRouter as Router, Route, Link } from "react-router-dom";
function ConnectionReport() {
    const [loading, setLoading] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [error, setError] = useState(null);
    const [rowsData, setRowsData] = useState([]);
    const [connectionReport, setConnectionReport] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "ascending" });
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage] = useState(100);
    const user = getCookie('user');
    const [searchQuery, setSearchQuery] = useState("");
    const [formData, setFormData] = useState({ connectiontype: "", date: "", toDate: "" })
    const initialFormData = { connectiontype: "", date: "", toDate: "" }  
      const [stbCount, setStbCount] = useState(true);
    const handleClear = () => { setFormData(initialFormData); };
    const handleClick = (acc_num) => { navigate(`/customerHistory/${acc_num}`); };
    const EditClick = (acc_num) => { navigate(`/customeredit/${acc_num}`); };
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }
    if (!user) { navigate('/login'); }
    function handleChange(e) {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    function handleSubmit(e) {
        setIsButtonDisabled(true);
        e.preventDefault();
        console.log("Form Data:", formData); handleReport();
        async function handleReport() {
            try {
                const response = await axios.post('https://node.cabletvpay.in/connectionReportSpecific', { user, formData });
                if (response.status === 200) {
                    console.log(response.data);
                    setStbCount(response.data.result.length);
                    setConnectionReport(response.data.result);
                    setIsButtonDisabled(false);
                }
            } catch (err) {
                toast.error(err.response?.data?.message || "Error fetching data");
                setIsButtonDisabled(false)
            }
        }
    }
    const downloadCSV = () => {
        const headers = [
            "Sl_No", "Status", "Edit", "Select", "Pay", "Name", "Account_No", "Code", "STB_No",
            "D_No", "Flat_Name", "Street", "Mobile_No", "Pay_Status", "Plan_Amount", "Paid_Amount",
            "Paid_Date", "Balance_Amount", "Discount_Amount", "Advance_Amount", "Pending_Amount",
            "Staff_Code", "Network", "Paid_Time", "Packages", "History", "Location", "Collection_Staff", "Delete"
        ];
        const csvRows = [];
        csvRows.push(headers.join(","));
        rowsData.forEach(row => {
            csvRows.push([row.Sl_No, row.Status, row.Edit, row.Select, row.Pay, row.Name, row.Account_No,
            row.Code, row.STB_No, row.D_No, row.Flat_Name, row.Street, row.Mobile_No,
            row.Pay_Status, row.Plan_Amount, row.Paid_Amount, row.Paid_Date, row.Balance_Amount,
            row.Discount_Amount, row.Advance_Amount, row.Pending_Amount, row.Staff_Code, row.Network,
            row.Paid_Time, row.Packages, row.History, row.Location, row.Collection_Staff].join(","));
        });

        const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "CableTvPay.csv");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = connectionReport.slice(indexOfFirstRow, indexOfLastRow);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    const totalPages = Math.ceil(connectionReport.length / rowsPerPage);
    const filteredRows = currentRows.filter((row) => Object.values(row).some(value => String(value).toLowerCase().includes(searchQuery.toLowerCase())));
    const stb = useMemo(() => connectionReport.map(row => parseInt(row.serial_num, 10)), [connectionReport]);
    const handleCopyToClipboard = () => { navigator.clipboard.writeText(stb).then(() => { toast.info(`${stbCount} STB numbers copied`); }).catch((error) => { toast.warning("not copied: " + error); }); };
    return (
        <div className="content-wrapper">
            <div className="content-header pt-1">
                <div className="my-3">
                    <div className="fs-4 valuesDec h4">CONNECTION REPORT</div>
                </div>
                <hr />
                <div className="card mt-3 mb-2 p-2">
                    <div className="card-header mb-1 text-center py-1">
                        <h5>Search Customer Details</h5>
                    </div>
                    <div className="border-1 px-1">
                        <form method="get" onSubmit={handleSubmit}>
                            <div className="row mx-3 d-flex justify-content-center">
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="connectiontype" className="text-center valuesDec text-navy">Choose Connection Type</label>
                                        <select className="form-control bg-gradient-navy text-white border-0 elevation-3" id="connectiontype" name="connectiontype" value={formData.connectiontype} onChange={handleChange}>
                                            <option value=""></option>
                                            <option value="new_connection">New Connection</option>
                                            <option value="re_connection">Re-Connection</option>
                                            <option value="shift_connection">Shift Connection</option>
                                            <option value="active">Active</option>
                                            <option value="deactive">Deactive</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="date" className="text-center valuesDec text-navy">From</label>
                                        <input type="date" className="form-control text-white bg-gradient-navy border-0 elevation-3" name="date" id="date" value={formData.date} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-12 mb-2">
                                    <div className="form-group">
                                        <label htmlFor="toDate" className="text-center valuesDec text-navy">To</label>
                                        <input type="date" className="form-control text-light bg-gradient-navy border-0 text-white elevation-3" name="toDate" id="toDate" value={formData.toDate} onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-3 col-6 py-4 pt-1 d-flex justify-content-center">
                                    <input type="submit" className="btn border-0  bg-info filterBtn text-light pb-3 pb-lg-1 w-100" disabled={isButtonDisabled} value="Filter" />
                                </div>
                                <div className="col-lg-1 col-md-3 col-6  py-4 pt-1 d-flex justify-content-center">
                                    <button type="button" className="btn border-0 bg-danger filterBtn text-light  pb-3 pb-lg-1 w-100" onClick={handleClear} > Clear </button>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>

                <div className="card elevation-5 mt-3 mt-lg-5" style={{ backgroundColor: "#cccccc" }}>
                    <div className="card-header filterBtn">
                        <div className="row">
                            {/* Header Title */}
                            <div className="col-lg-4">
                                <div className="text-left mb-lg-0 w-50">
                                    <h4 className="pb-0 mb-0 mt-1 text-navy">Filter Details</h4>
                                </div>
                            </div>
                            {/* Actions */}
                            <div className="col-lg-8 mt-1">
                                <span>
                                    <div className="row w-auto">
                                        {/* Search Bar */}
                                        <div className="col-11 col-lg-6">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control text-navy bg-light border-0 px-1 py-0"
                                                    placeholder="Search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ borderRadius: "5px 0 0 5px" }}
                                                />
                                                <span
                                                    className="input-group-text bg-light text-navy border-0 px-2"
                                                    id="basic-addon1"
                                                    style={{ borderRadius: "0 5px 5px 0" }}
                                                >
                                                    <i className="fas fa-search" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1 mt-lg-0">
                                            <div className="d-flex justify-content-end">
                                                <div className=" btn-group">
                                                    <button
                                                        onClick={downloadCSV}
                                                        className="btn btn-dark border-right px-lg-3 px-5"
                                                    >
                                                        <i className="fas fa-download" /> Download
                                                    </button>
                                                     <button type="button" className="btn btn-dark border-left px-lg-3 px-5 my-1 d-flex" data-toggle="modal" onClick={handleCopyToClipboard} data-target="#exampleModal"> <i className="far fa-copy pt-1 px-1" /> STBCOPY-{stbCount} </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>


                    <div className="card-body p-0">
                        <table id="myTable" className="table table-striped bg-white table-bordered table-responsive">
                            <thead className="bg-gradient-navy">
                                <tr>
                                    {/* Table headers with sorting functionality */}
                                    <th>Sl_No</th>
                                    <th>Edit </th>
                                    <th> Customer__Name</th>
                                    <th>Acc_no</th>
                                    <th>Code</th>
                                    <th>STB_no</th>
                                    <th>D_no</th>
                                    <th>Flat_name</th>
                                    <th>Street__name</th>
                                    <th>Phone</th>
                                    <th>Pay Status</th>
                                    <th>Plan Amount</th>
                                    <th>Paid Amount</th>
                                    <th>Paid__Date</th>
                                    <th>Balance Amount</th>
                                    <th>Discount Amount</th>
                                    <th>Advance Amount</th>
                                    <th>Pending_Amount</th>
                                    <th>Staff__Code</th>
                                    <th>Networks</th>
                                    <th>Paid Time</th>
                                    <th>Packages</th>

                                    <th>Collection Staff</th>
                                    <th>Connection Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredRows.length > 0 ? (
                                    filteredRows.map((row, index) => (
                                        <tr key={index}>
                                         <td>{index + 1}</td> {/* Using 'index' from map function */}
                                            <td onClick={() => EditClick(row.acc_num)}>
                                                <div className="d-flex justify-content-center">
                                                    <i className="fas fa-edit text-navy h5 mt-3 pt-1"></i>
                                                </div>
                                            </td>

                                            <td className='text-bold tableText name' onClick={() => handleClick(row.acc_num)}>{row.name}</td>
                                            <td className='tableText'>{row.account_num}</td>
                                            <td className='tableText'>{row.acc_num}</td>
                                            <td className='tableText'>{row.serial_num}</td>
                                            <td className='tableText'>{row.doorno}</td>
                                            <td className='tableText'>{row.flat_name}</td>
                                            <td className='tableText'>{row.street}</td>
                                            <td className='tableText'>{row.mobile}</td>
                                            <td className='tableText'>{row.status}</td>
                                            <td className='tableText'>{row.pay_amt}</td>
                                            <td className='tableText'>{row.paid_amt}</td>
                                            <td className='tableText'>{row.paid_date}</td>
                                            <td className='tableText'>{row.balance_amt}</td>
                                            <td className='tableText'>{row.discount}</td>
                                            <td className='tableText'>{row.extra_balance_amt}</td>
                                            <td className='tableText'>{row.pend_amt}</td>
                                            <td className='tableText'>{row.area_code}</td>
                                            <td className='tableText'>{row.net_name}</td>
                                            <td className='tableText'>{row.paid_time}</td>
                                            <td className='tableText'>{row.package}</td>

                                            <td className='tableText'>{row.col_boy}</td>
                                            <td>
                                                {row.con_status === "active" || row.con_status === "Active" ? (
                                                    <button className="btn btn-success">Active</button>
                                                ) : row.con_status === "active" || row.con_status === "Active" ? (
                                                    <div className="d-flex-column"><button className="btn btn-success">active </button></div>
                                                ) : (
                                                    <div className="d-flex-column"><button className="btn btn-secondary">{row.con_status}</button></div>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="30">No results found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div className="card-footer">
                        <div className="d-flex justify-content-end">
                            <div className="pagination btn-group border-light">
                                <button className="btn btn-dark border-right" onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} style={{ opacity: currentPage === 1 ? 0.6 : 1 }} ><i className="fas fa-backward" /></button>
                                <button onClick={() => paginate(1)} className={`btn ${currentPage === 1 ? "bg-gradient-green border-light active" : "btn-dark"} border-left`} > 1 </button>
                                {currentPage > 3 && <span className="mx-1">...</span>}
                                {Array.from({ length: 3 }, (_, i) => currentPage - 1 + i)
                                    .filter((page) => page > 1 && page < totalPages)
                                    .map((page) => (
                                        <button key={page} onClick={() => paginate(page)} className={`btn ${currentPage === page ? "bg-gradient-green border-light active" : "btn-dark"}`} style={{ fontWeight: currentPage === page ? "bold" : "normal" }} > {page} </button>
                                    ))}
                                {currentPage < totalPages - 2 && <span className="mx-1">...</span>}
                                {totalPages > 1 && (
                                    <button onClick={() => paginate(totalPages)} className={`btn ${currentPage === totalPages ? "bg-gradient-green border-light active" : "btn-dark"} border-right`} > {totalPages} </button>
                                )}
                                <button className="btn btn-dark  border-left" onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} style={{ opacity: currentPage === totalPages ? 0.6 : 1 }} > <i className="fas fa-forward"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ConnectionReport;
